module.exports = __webpack_public_path__ + "img/appreciateTitle.f05970ec.png";